import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Grid, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { countryRequest } from "../../../api/CountryRequest";

interface Props {
  open: boolean;
  onClose: AnyFunction;
  onCountryCreated: AnyFunction;
}

export default function AddCountryDialog(props: Props) {
  const { open, onClose, onCountryCreated } = props;
  const [formValues, setFormValues] = useState<any>({
    name: null,
  });

  const [error, setError] = useState({
    name: false,
    nameIsDuplicate: false,
  });

  const [countryData, setCountryData] = useState<Country[]>([]);

  const fetchCountries = () => {
    countryRequest
      .getCountries()
      .then((countries) => setCountryData(countries));
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const checkNameIsDuplicate = (country: Country) =>
    country.name?.toLowerCase() === formValues.name?.toLowerCase();

  const handleErrors = () => {
    if (!formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: true,
      }));
    } else if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: false,
      }));
    }
    if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        nameIsDuplicate: countryData.some(checkNameIsDuplicate),
      }));
    }
  };

  const handleSubmit = () => {
    handleErrors();
    const formIsValid =
      formValues.name && !countryData.some(checkNameIsDuplicate);
    if (formIsValid) {
      return countryRequest
        .createCountry(formValues)
        .then((createdCountry) => {
          if (typeof onCountryCreated === "function") {
            onCountryCreated(createdCountry);
          }
        })
        .catch(() => {
          alert("S-a produs o eroare!");
        });
    }
  };

  const handleCloseAddCountryDialog = () => {
    onClose();
    setFormValues(() => ({
      name: null,
    }));
    setError(() => ({
      name: false,
      nameIsDuplicate: false,
    }));
  };

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="xs">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <DialogTitle sx={{ pb: 0 }}>Adăugare țară</DialogTitle>
          </Grid>
          <Grid item sx={{ mr: 2, pt: 2 }}>
            <IconButton onClick={handleCloseAddCountryDialog} tabIndex={-1}>
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent>
          <TextField
            required
            label="Nume"
            size="small"
            fullWidth
            error={error.name || error.nameIsDuplicate}
            helperText={
              error.name
                ? "Câmp obligatoriu!"
                : error.nameIsDuplicate && "Nume deja existent!"
            }
            onChange={(event) =>
              setFormValues((prev: any) => ({
                ...prev,
                name: event.target.value.toUpperCase(),
              }))
            }
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleSubmit()
                  ?.then(handleCloseAddCountryDialog)
                  .then(fetchCountries);
              }
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          ></TextField>
          <Divider sx={{ mb: 2, opacity: 0 }} />
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleSubmit()
                    ?.then(handleCloseAddCountryDialog)
                    .then(fetchCountries);
                }}
              >
                Salvează
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseAddCountryDialog}
              >
                Renunță
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
